export enum eAsnState {
  Pending = 1,
  Received = 2,
  Controlling = 3,
  Controlled = 4,
  Locating = 5,
  Located = 6,
  Finished = 7,
  Cancelled = 8,
  Deleted = 9,
  ReceptionMassive = 10,
  PreReception = 11,
  LocatedES = 12, // ES = External Storage
  PendingResponseES = 13,
  FinishedCompleteES = 14,
  FinishedIncompleteES = 15,
  created = 16
}

export const asnDeleteStates: number[] = [
  eAsnState.Pending,
  eAsnState.Received,
  eAsnState.Controlled
]

export const asnFinishedStates: number[] = [
  eAsnState.Finished,
  eAsnState.PendingResponseES,
  eAsnState.FinishedCompleteES,
  eAsnState.FinishedIncompleteES
]

// Sirve para chip de ubicación
// estados en los que la ASN ya completó su almacenamiento.
// Interna: Finalizada. Externa: Finalizada AE, completa o incompleta.
export const asnStoredStates: number[] = [
  eAsnState.Finished,
  eAsnState.FinishedCompleteES,
  eAsnState.FinishedIncompleteES
]
